import { createFileRoute } from "@tanstack/react-router";
import { AutosLegacyRedirect } from "@/pages/legacy/LegacyRedirects";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/autos/")({
  head: () => routeHead("/de/autos/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AutosLegacyRedirect />
  );
}
